import { forwardRef } from 'react'

import Grid from '@material-ui/core/Grid'
import Alert from '@material-ui/lab/Alert'

import { ButtonPrimary, ButtonSecondary } from '@base/Button/Button';
import Dialog from "@base/Dialog";

export const MudarEnvelopeDeCaixaDialog = forwardRef((props, ref) => {

  return (
    <Dialog
      maxWidth={'md'}
      fullWidth={true}
      closeDialog={props.aoFechar}
      openDialog={props.aberto}
      title='Deseja mudar o envelope de caixa?'
    >
        <Grid item container spacing={4} justify="center">

          <Grid item sm={12} lg={12}>
            <Alert severity="warning">Este envelope consta como armazenado na caixa {props.objetoPostal.caixaCodigo} posição {props.objetoPostal.posicaoNaCaixa}. Deseja mesmo mudar o local de armazenamento?</Alert>
          </Grid>

          <Grid item sm={2} lg={2}>
            <ButtonPrimary
              onClick={() => props.handlerMudarDeCaixa(props.objetoPostal)}
              name="Sim"
            />
          </Grid>

          <Grid item sm={2} lg={2}>
            <ButtonSecondary
              onClick={() => props.aoFechar()}
              name="Não"
            />
          </Grid>

        </Grid>

    </Dialog>
  );
})

export default MudarEnvelopeDeCaixaDialog;
